import { render, staticRenderFns } from "./BtnCopiar.vue?vue&type=template&id=738cfbaf&"
import script from "./BtnCopiar.vue?vue&type=script&lang=js&"
export * from "./BtnCopiar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports